'use client';

import { useEffect, useState } from 'react';
import {
  type DesktopAppPlatform,
  getDesktopAppPlatform,
} from '@frameio/utils/browser';

export const useDesktopAppPlatform = () => {
  const [platform, setPlatform] = useState<DesktopAppPlatform>(null);

  useEffect(() => {
    let cancelled = false;

    getDesktopAppPlatform().then((detected) => {
      if (!cancelled) setPlatform(detected);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return platform;
};
